import { CATALOG_BOOKSET_LIST_SET_DATA } from 'rebook/apps/catalog/constants';


const initialState = {
  paginateBy: 10,
  pageNumber: 1,
  lastPageNumber: 0,
  rubricInfo: null,
};

export default function booksetList(state = initialState, action) {
  switch (action.type) {
    case CATALOG_BOOKSET_LIST_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
